import { render, staticRenderFns } from "./IncidenteServiciosPublicosIcon.vue?vue&type=template&id=3743a2b0&scoped=true"
import script from "./IncidenteServiciosPublicosIcon.vue?vue&type=script&lang=js"
export * from "./IncidenteServiciosPublicosIcon.vue?vue&type=script&lang=js"
import style0 from "./IncidenteServiciosPublicosIcon.vue?vue&type=style&index=0&id=3743a2b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3743a2b0",
  null
  
)

export default component.exports